// Recupera o desenho de um canvas do editor (fabric) quando o navegador perde
// o conteúdo dos canvas.
//
// Com a memória de vídeo esgotada (ou a GPU reiniciando), o Chrome apaga o
// conteúdo dos canvas sem avisar o fabric. O fundo branco continua sendo
// pintado a cada renderAll, mas a foto vinha de canvas guardados (o cache de
// cada objeto e a foto com filtro): o editor e a prévia ficavam brancos, e
// desenhar de novo não adiantava, porque as fontes estavam vazias.
//
// Sem import do fabric: os testes rodam em ambiente node.

// Etapa 1: refaz a partir do que ainda está na memória. Marca todo objeto
// para redesenhar o próprio cache e refaz os filtros das imagens a partir da
// imagem original (o canvas com o filtro pode ter sido apagado).
export function redesenharCanvas(canvasInst) {
  if (!canvasInst || !canvasInst.getObjects) return;
  canvasInst.getObjects().forEach((objeto) => {
    if (
      objeto.filters &&
      objeto.filters.length &&
      objeto._originalElement &&
      typeof objeto.applyFilters === "function"
    ) {
      try {
        objeto.applyFilters();
      } catch (erro) {
        console.warn("Falha ao refazer filtros da imagem", erro);
      }
    }
    objeto.dirty = true;
  });
  canvasInst.renderAll();
}

// Etapa 2: baixa de novo cada foto do canvas (objetos com `fotoSrc`) e troca a
// imagem do objeto. Posição, escala e filtros continuam os mesmos: setElement
// do fabric refaz os filtros sobre a imagem nova. Uma foto que não baixar fica
// como está.
export async function recarregarFotosDoCanvas(canvasInst, carregar) {
  if (!canvasInst || !canvasInst.getObjects) return 0;
  const fotos = canvasInst
    .getObjects()
    .filter(
      (objeto) => objeto.fotoSrc && typeof objeto.setElement === "function"
    );
  let recarregadas = 0;
  for (const foto of fotos) {
    try {
      const elemento = await carregar(foto.fotoSrc);
      foto.setElement(elemento);
      foto.dirty = true;
      recarregadas += 1;
    } catch (erro) {
      console.warn("Falha ao baixar de novo a foto do canvas", erro);
    }
  }
  redesenharCanvas(canvasInst);
  return recarregadas;
}

// Recuperação a usar entre as tentativas de exportar a foto: na 1ª falha
// redesenha com o que está na memória; da 2ª em diante baixa a foto de novo.
export function criarRecuperacaoDoCanvas(canvasInst, carregar) {
  return async (tentativaQueFalhou) => {
    if (tentativaQueFalhou <= 1) {
      redesenharCanvas(canvasInst);
      return;
    }
    await recarregarFotosDoCanvas(canvasInst, (src) =>
      carregar(src, tentativaQueFalhou)
    );
  };
}
